import React, { useEffect, useState } from 'react';
import { useMap } from 'react-leaflet';

/**
 * Map Diagnostics Component
 * Displays real-time map status and helps debug tile loading issues
 */
const MapDiagnostics = () => {
  const map = useMap();
  const [diagnostics, setDiagnostics] = useState({
    center: null,
    zoom: null,
    bounds: null,
    size: null,
    tilesLoading: 0,
    tilesLoaded: 0,
    tileErrors: 0,
  });

  useEffect(() => {
    if (!map) return;

    // Update diagnostics
    const updateDiagnostics = () => {
      setDiagnostics({
        center: map.getCenter(),
        zoom: map.getZoom(),
        bounds: map.getBounds(),
        size: map.getSize(),
        tilesLoading: 0,
        tilesLoaded: 0,
        tileErrors: 0,
      });
    };

    // Initial update
    updateDiagnostics();

    // Listen to map events
    map.on('moveend', updateDiagnostics);
    map.on('zoomend', updateDiagnostics);
    map.on('resize', updateDiagnostics);

    // Tile loading events
    let tilesLoading = 0;
    let tilesLoaded = 0;
    let tileErrors = 0;

    map.on('tileloadstart', () => {
      tilesLoading++;
      setDiagnostics(prev => ({ ...prev, tilesLoading }));
    });

    map.on('tileload', () => {
      tilesLoaded++;
      tilesLoading = Math.max(0, tilesLoading - 1);
      setDiagnostics(prev => ({ ...prev, tilesLoaded, tilesLoading }));
    });

    map.on('tileerror', () => {
      tileErrors++;
      tilesLoading = Math.max(0, tilesLoading - 1);
      setDiagnostics(prev => ({ ...prev, tileErrors, tilesLoading }));
    });

    // Log initial state
    console.log('🗺️ Map Diagnostics Initialized');
    console.log('Center:', map.getCenter());
    console.log('Zoom:', map.getZoom());
    console.log('Size:', map.getSize());
    console.log('Bounds:', map.getBounds());

    // Force invalidate size
    setTimeout(() => {
      map.invalidateSize();
      console.log('🔄 Map size invalidated');
    }, 100);

    return () => {
      map.off('moveend', updateDiagnostics);
      map.off('zoomend', updateDiagnostics);
      map.off('resize', updateDiagnostics);
    };
  }, [map]);

  // Don't render anything visible (diagnostics are in console)
  return null;
};

export default MapDiagnostics;
